import CollapsibleList, { CollapsibleListProps } from './CollapsibleList';
import CollapsibleListItem, { CollapsibleListItemProps } from './CollapsibleListItem';

export type { CollapsibleListProps, CollapsibleListItemProps };
export { CollapsibleListItem };
export default CollapsibleList;
